module.exports = __webpack_public_path__ + "img/aboutus-s1.bbe13a48.jpg";